import styled from "styled-components";
import {GAMING_HISTORY_PAGE, NEW_LIVE_CASINO_PAGE, TIPPING_HISTORY_PAGE} from "../../../../themes/css-global-classes";

export const TopBannerDefaultBox = styled.div`
  position: relative;
  width: 100%;
  transition: all 0.03s ease-in-out;
  padding-bottom: calc(200 / 1750 * 100%);

  .${NEW_LIVE_CASINO_PAGE} & {
    padding-bottom: calc(204 / 1712 * 100%);
  }

  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    padding-bottom: calc(165 / 1024 * 100%);
    .${NEW_LIVE_CASINO_PAGE} &, .${GAMING_HISTORY_PAGE} &, .${TIPPING_HISTORY_PAGE} &{
      padding-bottom: calc(122 / 1024 * 100%);
    }
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    padding-bottom: calc(105 / 414 * 100%);
    .${GAMING_HISTORY_PAGE} &, .${TIPPING_HISTORY_PAGE} &{
        padding-bottom: calc(77 / 600 * 100%);
    }
    .${NEW_LIVE_CASINO_PAGE} & {
      padding-bottom: calc(77 / 414 * 100%);
    }
  }
`;